import Vue from 'vue';
import { Message } from 'element-ui';
import ConfirmComponent from './tpl';

let instance;
let ConfirmConstructor = Vue.extend(ConfirmComponent);

let initInstance = () => {
  instance = new ConfirmConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

let Confirm = (content, title = '', options = {}) => {
  initInstance();
  instance.content = content;
  instance.title = title || '提示';
  instance.isredbtn = options.isredbtn || false;
  instance.canceltxt = options.canceltxt || '取消';
  instance.confirmtxt = options.confirmtxt || '确认';
  return new Promise((resolve, reject) => {
    instance.show = true;
    instance.success = (type) => {
      if (!type) {
        Message.warning('请选择批量处理方式');
        return;
      }
      resolve(true);
      instance.show = false;
    };
    instance.cancel = () => {
      reject(false);
      instance.show = false;
    }
  })
};

export default {
  install: function (Vue, options = {}) {
    Vue.prototype.$ztxConfirmH = Confirm;
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmH/index.js